import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Frame.module.css';

interface FrameProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * The glowing tech border that anchors a panel on the page. It is a 9-slice image
 * (ui/frames/tech-frame.svg via CSS border-image): corners keep a fixed size and the edges stretch,
 * so the frame stays crisp around content of any size on any screen. Put a `Surface` or other
 * content inside; it sits within the frame's dark band.
 */
export function Frame({ className, children, ...rest }: FrameProps) {
  return (
    <div className={cx(styles.frame, className)} {...rest}>
      {children}
    </div>
  );
}
